import { DefaultService } from '@/services/DefaultService';

export default class CategoriaConfigService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllCombo(...params) {
        return this._http.get(`${this._env}/config/getcombo/categoriaconfig.json?param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllComboUser(idusuario, ...params) {
        return this._http.get(`${this._env}/config/getcombo/categoriaconfiguser.json?idusuario=${idusuario}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}